import * as React from 'react';
import { useSelector } from 'react-redux';
import Head from 'next/head';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReduxState } from 'ducks';
import { selectBookingWidgetHeaderDescription } from 'lib/util/bookingWidgetDesign';
import { ProductDetails } from 'components/ProductDetails/ProductDetails';
import { FrequentlyViewedProducts } from 'components/FrequentlyViewedProducts/FrequentlyViewedProducts';
import { toProductShape } from 'lib/util/productShape';
import { getProductStructuredReviewData } from 'lib/util/getProductStructuredReviewData';
import { AnnualPassRecommendationProducts } from 'components/AnnualPassRecommendationProducts/AnnualPassRecommendationProducts';
import { useRouter } from 'next/router';

export const BookingWidgetProductDetails = () => {
  const { t } = useTranslation();
  const isGroupBooking = !!useRouter().query.groupId;

  const apiProduct = useSelector((state: ReduxState) => state.server.product.product);
  const headerText = useSelector(selectBookingWidgetHeaderDescription);
  const reviews = useSelector((state: ReduxState) => state.universal.reviews.all);

  if (!apiProduct) {
    return (
      <div>
        <Typography variant="h5" component="h3">
          {t('Product not found')}
        </Typography>
      </div>
    );
  }

  const product = toProductShape(apiProduct);

  const title = `${product.name || ''} | ${headerText}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        {apiProduct?.booking_widget_settings?.is_hidden_from_product_list_and_search && (
          <meta name="robots" content="noindex" />
        )}
        {apiProduct != null && reviews != null && (apiProduct?.review_count ?? 0) > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(getProductStructuredReviewData(apiProduct, reviews)),
            }}
          />
        )}
      </Head>
      <ProductDetails />
      {!isGroupBooking /* Don't show marketing-related items on group booking pages */ && (
        <>
          <AnnualPassRecommendationProducts />
          <FrequentlyViewedProducts />
        </>
      )}
    </>
  );
};
